import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {MessageService} from "@services";
import {Message} from "@model";

export const MessageResolver: ResolveFn<Observable<Message[]> | Message[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   messageService: MessageService = inject(MessageService)): Observable<Message[]> | Message[] => {
    return messageService.getUserMessages(route.queryParams['read'] === 'true');
  }
